"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Provider = exports.Consumer = exports.useCard = exports.cardDefault = void 0;

var React = _interopRequireWildcard(require("react"));

var cardDefault = {
  setExpandedSections: function setExpandedSections() {},
  addSection: function addSection() {},
  isOpened: false,
  removeSection: function removeSection() {},
  roundedBorders: {
    top: false,
    bottom: false
  },
  index: 0,
  noBorderTop: false
};
exports.cardDefault = cardDefault;
var context = /*#__PURE__*/React.createContext(cardDefault);
context.displayName = "CardOrbitContext";

var useCard = function useCard() {
  return React.useContext(context);
};

exports.useCard = useCard;
var Consumer = context.Consumer,
    Provider = context.Provider;
exports.Provider = Provider;
exports.Consumer = Consumer;